// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type OrganizationOverviewServerGroupTableQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type OrganizationOverviewServerGroupTableQuery = {
  __typename?: "GraphqlQuery";
  getSummaryStatsByServerGroup: Array<{
    __typename?: "ServerGroupSummaryStats";
    id: string;
    clusterId?: string | null;
    serverCount: number;
    databaseCount: number;
    warningsCount: number;
    criticalsCount: number;
    serverGroup: {
      __typename?: "ServerGroup";
      id: string;
      name: string;
      primaryServerHumanId?: string | null;
    };
    servers: Array<{
      __typename?: "ServerGroupServer";
      id: string;
      name: string;
      humanId: string;
      databaseCount: number;
      warningsCount: number;
      criticalsCount: number;
      latestStats?: {
        __typename?: "PostgresServerStats";
        isPrimary: boolean;
      } | null;
    }>;
  }>;
};

export const OrganizationOverviewServerGroupTableDocument = gql`
  query OrganizationOverviewServerGroupTable($organizationSlug: ID!) {
    getSummaryStatsByServerGroup(organizationSlug: $organizationSlug) {
      id
      clusterId
      serverGroup {
        id
        name
        primaryServerHumanId
      }
      serverCount
      databaseCount
      warningsCount
      criticalsCount
      servers {
        id
        name
        humanId
        databaseCount
        warningsCount
        criticalsCount
        latestStats {
          isPrimary
        }
      }
    }
  }
`;

/**
 * __useOrganizationOverviewServerGroupTableQuery__
 *
 * To run a query within a React component, call `useOrganizationOverviewServerGroupTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationOverviewServerGroupTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationOverviewServerGroupTableQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useOrganizationOverviewServerGroupTableQuery(
  baseOptions: Apollo.QueryHookOptions<
    OrganizationOverviewServerGroupTableQuery,
    OrganizationOverviewServerGroupTableQueryVariables
  > &
    (
      | {
          variables: OrganizationOverviewServerGroupTableQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OrganizationOverviewServerGroupTableQuery,
    OrganizationOverviewServerGroupTableQueryVariables
  >(OrganizationOverviewServerGroupTableDocument, options);
}
export function useOrganizationOverviewServerGroupTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrganizationOverviewServerGroupTableQuery,
    OrganizationOverviewServerGroupTableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OrganizationOverviewServerGroupTableQuery,
    OrganizationOverviewServerGroupTableQueryVariables
  >(OrganizationOverviewServerGroupTableDocument, options);
}
// @ts-ignore
export function useOrganizationOverviewServerGroupTableSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrganizationOverviewServerGroupTableQuery,
    OrganizationOverviewServerGroupTableQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OrganizationOverviewServerGroupTableQuery,
  OrganizationOverviewServerGroupTableQueryVariables
>;
export function useOrganizationOverviewServerGroupTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OrganizationOverviewServerGroupTableQuery,
        OrganizationOverviewServerGroupTableQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OrganizationOverviewServerGroupTableQuery | undefined,
  OrganizationOverviewServerGroupTableQueryVariables
>;
export function useOrganizationOverviewServerGroupTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OrganizationOverviewServerGroupTableQuery,
        OrganizationOverviewServerGroupTableQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OrganizationOverviewServerGroupTableQuery,
    OrganizationOverviewServerGroupTableQueryVariables
  >(OrganizationOverviewServerGroupTableDocument, options);
}
export type OrganizationOverviewServerGroupTableQueryHookResult = ReturnType<
  typeof useOrganizationOverviewServerGroupTableQuery
>;
export type OrganizationOverviewServerGroupTableLazyQueryHookResult =
  ReturnType<typeof useOrganizationOverviewServerGroupTableLazyQuery>;
export type OrganizationOverviewServerGroupTableSuspenseQueryHookResult =
  ReturnType<typeof useOrganizationOverviewServerGroupTableSuspenseQuery>;
export type OrganizationOverviewServerGroupTableQueryResult =
  Apollo.QueryResult<
    OrganizationOverviewServerGroupTableQuery,
    OrganizationOverviewServerGroupTableQueryVariables
  >;
